import {
  Button,
  PortfolioAssetsChart,
  PortfolioAssetsList,
  Section,
} from '@/components';
import { useWalletsContext } from '@/components/providers';
import APP_CONFIG from '@/config/app';
import { WalletUnderlyingYieldBearingAssetInterface } from '@/interfaces';
import { URLS } from '@/utils/constants';
import { PORTFOLIO } from '@/utils/strings';
import { useRouter } from 'next/router';
import { FC, useCallback } from 'react';
const { MAIN_GAP } = APP_CONFIG.STYLES;
interface PortfolioAssetsSectionProps {
  assets: WalletUnderlyingYieldBearingAssetInterface[];
  noOfItemsToShow?: number;
  showShortList?: boolean;
  isFullBleed?: boolean;
  isBackgroundTransparent?: boolean;
  showSection?: boolean;
  showSeeAllOrDetailsButton?: boolean;
}
const PortfolioAssetsSection: FC<PortfolioAssetsSectionProps> = ({
  assets,
  noOfItemsToShow = 0,
  showShortList = false,
  isFullBleed = false,
  isBackgroundTransparent = false,
  showSection = true,
  showSeeAllOrDetailsButton = false,
}) => {
  const { tokensAndUnderlyingYieldBearingAssets } = useWalletsContext();
  const router = useRouter();
  const buttonText =
    noOfItemsToShow < tokensAndUnderlyingYieldBearingAssets.length
      ? 'See all'
      : 'See details';
  const handleSeeAllClick = useCallback(() => {
    router.push(URLS.portfolio);
  }, [router]);
  const content = (
    <div className={`flex flex-col gap${MAIN_GAP}`}>
      <PortfolioAssetsChart assets={assets} noOfItemsToShow={0} />
      <PortfolioAssetsList
        noOfItemsToShow={noOfItemsToShow}
        showShortList={showShortList}
      />
    </div>
  );
  return showSection ? (
    <Section
      headerTitle={PORTFOLIO.HEADER}
      subHeader={PORTFOLIO.SUB_HEADER}
      headerRightNode={
        showSeeAllOrDetailsButton && (
          <Button intent="ghost" onClick={handleSeeAllClick}>
            {buttonText}
          </Button>
        )
      }
      body={content}
      isFullBleed={isFullBleed}
      isBackgroundTransparent={isBackgroundTransparent}
    />
  ) : (
    content
  );
};
export default PortfolioAssetsSection;
